<template>
    <a class="text-white whitespace-no-wrap" :class="['cursor-pointer']" @click.prevent="onLogout">
        <slot>{{ text }}</slot>

        <form ref="formLogout" action="/logout" method="POST" style="display: none;">
            <input type="hidden" name="_token" :value="token">
        </form>
    </a>
</template>

<script>
    import { call } from 'vuex-pathify'
    import helpersMixin from '../mixins/helpers'

    export default {
        props: {
            text: {
                type: String,
                default: 'Log out'
            },
        },

        data() {
            return {
                token: document.head.querySelector('meta[name="csrf-token"]').content,
            }
        },

        mixins: [
            helpersMixin
        ],

        methods: {
            logout: call('auth/logout'),

            onLogout() {
                this.logout()

                this.$refs.formLogout.submit()
            },
        },
    }
</script>
